module.exports = __webpack_public_path__ + "media/images/member_mypage_lead-9f11386c864e5ba2f395171582ae6dd6.png";